module.exports = __webpack_public_path__ + "static/img/partner_II.a722a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_II.png
// module id = Ncmy
// module chunks = 9